import { UserType } from '../types';

export const isExternalUser = (): boolean =>
  window.config.userType === UserType.External;
